import './App.css';
import { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Header from "./Header.js";
import Home from "./Home.js"
import Checkout from './Checkout';
import Login from './Login'
import { useStateValue } from "./StateProvider";
import {auth} from "./firebase.js";



function App() {
  const [{user}, dispatch] = useStateValue();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if(authUser){
        // the user is logged in 

        dispatch({
          type: 'SET_USER',
          user: authUser
        })        
      }
      else {
        // the user is logged out

        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })


    return () => {
      //cleanup
      unsubscribe();
    }
  }, [])

  console.log(user);

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/checkout">
            <Header />
            <Checkout/>
          </Route>

          <Route path="/login">
            <Login/>
          </Route>

          <Route path="/">
            <Header />
            <Home/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
